import { c as _c } from "react/compiler-runtime";
import ControlledTextField from "@components/hookform/TextField";
import { Button, Icon, InlineNotification } from "@justhome/react-ui";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import { useForm } from "react-hook-form";
import { Form, FormField, FormRow } from "../Form";
import StatusIcon from "../StatusIcon";
export interface ReconfirmationFormValues {
  phoneNumber: string;
}
interface ReconfirmationFormProps {
  onSubmit: (data: ReconfirmationFormValues) => void;
  onGoBack?: () => void;
  isLoading?: boolean;
  isError?: boolean;
}
const ReconfirmationForm = t0 => {
  const $ = _c(41);
  const {
    onSubmit,
    isLoading,
    isError
  } = t0;
  const {
    t
  } = useBookingTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    control,
    handleSubmit,
    formState: t2
  } = useForm(t1);
  const {
    errors
  } = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <StatusIcon color="success" icon="Check" />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t) {
    t4 = t("reconfirmationForm.title");
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <h2 className="text-h2 font-semibold text-center">{t4}</h2>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t) {
    t6 = t("reconfirmationForm.description");
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <p className="text-center">{t6}</p>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== handleSubmit || $[11] !== onSubmit) {
    t8 = handleSubmit(onSubmit);
    $[10] = handleSubmit;
    $[11] = onSubmit;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t) {
    t9 = t("reconfirmationForm.phoneNumberLabel");
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t("reconfirmationForm.phoneNumberRequiredError");
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = {
      required: t10
    };
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = errors.phoneNumber?.message;
  let t13;
  if ($[19] !== control || $[20] !== t11 || $[21] !== t12 || $[22] !== t9) {
    t13 = <FormRow><FormField><ControlledTextField name="phoneNumber" type="tel" label={t9} control={control} rules={t11} errorMessage={t12} /></FormField></FormRow>;
    $[19] = control;
    $[20] = t11;
    $[21] = t12;
    $[22] = t9;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== isError || $[25] !== t) {
    t14 = isError && <InlineNotification type="error" icon={<Icon type="Attention" />}>{t("formSection.error")}</InlineNotification>;
    $[24] = isError;
    $[25] = t;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t) {
    t15 = t("reconfirmationForm.submitButton");
    $[27] = t;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== isLoading || $[30] !== t15) {
    t16 = <Button variant="primary" form="reconfirmation-form" type="submit" size="md" shadow={true} fullWidth={true} isLoading={isLoading}>{t15}</Button>;
    $[29] = isLoading;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t13 || $[33] !== t14 || $[34] !== t16 || $[35] !== t8) {
    t17 = <Form id="reconfirmation-form" onSubmit={t8}>{t13}{t14}{t16}</Form>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t16;
    $[35] = t8;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t17 || $[38] !== t5 || $[39] !== t7) {
    t18 = <div className="flex flex-col gap-3s items-center w-[600px] max-w-full">{t3}{t5}{t7}{t17}</div>;
    $[37] = t17;
    $[38] = t5;
    $[39] = t7;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  return t18;
};
export default ReconfirmationForm;